import PropTypes from 'prop-types';

export default function Flag(props) {
  return <span className={ `flag-icon flag-icon-${ props.data.value.toLowerCase() }` } />;
}

Flag.propTypes = {
  data: PropTypes.object.isRequired,
};
